"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE_LAYBUY_APPLICATION = exports.ROUTE_LOAN_APPLICATION = void 0;
exports.ROUTE_LOAN_APPLICATION = "/loan-application";
exports.ROUTE_LAYBUY_APPLICATION = "/laybuy-application";
// TODO: Add more routes
